import React, { useState } from "react";
import CrudSettings from "./CrudSettings";
import ItemSetup from "./ItemSetup";
import "./ItemManagement.css";

const tabs = [
  { id: "items", label: "Items", icon: "boxes" },
  { id: "categories", label: "Categories", icon: "tags" },
  { id: "departments", label: "Departments", icon: "diagram-2" },
  { id: "locations", label: "Locations", icon: "geo-alt" },
];

export default function ItemManagement() {
  const [active, setActive] = useState("items");

  return (
    <section className="item-management">
      <div className="item-management__header">
        <div>
          <h2>Item management</h2>
          <p>
            Maintain stock items, service benefits, departments,
            categories and operating locations.
          </p>
        </div>
      </div>

      <div className="item-management__tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={active === tab.id ? "active" : ""}
            onClick={() => setActive(tab.id)}
          >
            <i className={`bi bi-${tab.icon}`}></i>
            {tab.label}
          </button>
        ))}
      </div>

      <div className="item-management__body">
        {active === "items" && <ItemSetup />}

        {active === "categories" && (
          <CrudSettings
            title="Item categories"
            description="Group items and services for reporting and control."
            path="item-categories"
            fields={[
              { name: "code", label: "Category code", readOnly: true },
              { name: "name", label: "Category name", required: true },
              { name: "notes", label: "Notes", type: "textarea", wide: true },
              { name: "is_active", label: "Active", type: "checkbox" },
            ]}
          />
        )}

        {active === "departments" && (
          <CrudSettings
            title="Item departments"
            description="Maintain departments responsible for items and services."
            path="item-departments"
            fields={[
              { name: "code", label: "Department code", readOnly: true },
              { name: "name", label: "Department name", required: true },
              { name: "notes", label: "Notes", type: "textarea", wide: true },
              { name: "is_active", label: "Active", type: "checkbox" },
            ]}
          />
        )}

        {active === "locations" && (
          <CrudSettings
            title="Item locations"
            description="Maintain branches, stores and service locations."
            path="item-locations"
            fields={[
              { name: "code", label: "Location code", readOnly: true },
              { name: "name", label: "Location name", required: true },
              { name: "address", label: "Address", type: "textarea", wide: true },
              { name: "city", label: "City" },
              { name: "contact_name", label: "Contact person" },
              { name: "contact_phone", label: "Contact phone", uppercase: false },
              { name: "contact_email", label: "Contact email", type: "email", uppercase: false },
              { name: "is_active", label: "Active", type: "checkbox" },
            ]}
          />
        )}
      </div>
    </section>
  );
}
